import { convertFeetToMeters } from 'utils/main';

export const changeObjectHeightUnit = (zones, heightUnitConversion) =>
  zones.map(zone => {
    if (heightUnitConversion) {
      zone.amsl_min = `${convertFeetToMeters(zone.amsl_min)}`;
      zone.amsl_max = `${convertFeetToMeters(zone.amsl_max)}`;
      return zone;
    }
    zone.amsl_min = `${zone.amsl_min}`;
    zone.amsl_max = `${zone.amsl_max}`;
    return zone;
  });
